import "./index.css";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { ErrorMessage as t } from "@design-system/error-message";
import { FieldHead as r } from "@design-system/field-head";
import a from "classnames";
import { forwardRef as s } from "react";
var l = s(function (_ref, _) {
  var s = _ref.className,
    l = _ref.id,
    i = _ref.rows,
    n = _ref.cols,
    d = _ref.name,
    m = _ref.label,
    c = _ref.textareaId,
    p = _ref.description,
    x = _ref.tooltipText,
    g = _ref.tooltipLabel,
    f = _ref.placeholder,
    h = _ref.errorMessage,
    b = _ref.onChange,
    B = _ref.onBlur;
  return e("div", Object.assign({
    ref: _,
    className: a("cds-long-text-field", s)
  }, {
    children: [o(r, {
      id: l,
      label: m,
      description: p,
      tooltipText: x,
      tooltipLabel: g
    }), o("textarea", {
      className: a("cds-long-text-field__textarea", {
        "cds-long-text-field__textarea--error": Boolean(h)
      }),
      cols: n,
      rows: i,
      name: d,
      placeholder: f,
      onChange: b,
      onBlur: B,
      "aria-invalid": Boolean(h),
      id: c
    }), o(t, {
      message: h
    })]
  }));
});
export { l as LongTextField };